export default __webpack_public_path__ + "alberta-activity-starttime.d20ee05194c96c8d73c2.svg";